'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    if (!canUseDom) return { top: 0, left: 0 };
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};
var canUseDom = exports.canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var getWindowDim = exports.getWindowDim = function getWindowDim() {
  if (!canUseDom) return { width: 1000, height: null };
  var width = document.documentElement.clientWidth || document.clientWidth || document.body.clientWidth || window.innerWidth;
  var height = document.documentElement.clientHeight || document.clientHeight || document.body.clientHeight || window.innerHeight;
  return { width: width, height: height };
};